import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SideBarDef } from 'ag-grid-community';
import * as Highcharts from 'highcharts';
import * as _moment from 'moment';

import { ToastrService } from 'ngx-toastr';
import { ImageDialogComponent } from '../analytical-tools/image-dialog/image-dialog.component';
import { CustomLoadingOverlay } from '../custom-loading-overlay.component';
import { PrimeCellEditorComponent } from '../editors/prime-cell-editor.component';
import { DtServiceService } from '../services/dtService.service';
import { OverallActionPlanService } from '../services/overall-actionPlan.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DatepickerService } from 'src/backend/services/datepicker.service';
import { BaseApi } from 'src/backend/api/base-api';
import { Employee } from 'src/backend/models/user/employee';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { AddActionModalComponent } from '../screens/addActionModal/addActionModal.component';
import { finalize } from 'rxjs/internal/operators/finalize';
import { ApplicationPermission } from '../user-management/shared/models/application-permission';
import { PermissionService } from 'src/backend/services/permission.service';
import { UserConfigurationsService } from '../services/user-configurations.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';

const moment = _moment;
declare var window: any;
interface status {
  statusId: number;
  name: string;
}

@Component({
  selector: 'app-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss'],
})
export class UserActionsComponent implements OnInit {
  @ViewChild('previewModal') private previewModal!: TemplateRef<any>;
  @ViewChild('addActionModal') private addActionModal!: TemplateRef<any>;
  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild('fileInputFile') fileInputFile!: ElementRef;
  @ViewChild('addImageInput') addImageInput!: ElementRef;
  @ViewChild('addFileInput') addFileInput!: ElementRef;
  blobStorageUrl = Constants.BLOB_STORAGE_URL;
  status: status[];
  selectedStatus: status[];
  filteredModule!: any[];
  filteredDepartments!: any[];
  filteredEmployee!: any[];
  dropdownSettings: any = {};
  // IsAccess: any;
  // IsWrite: any;
  filterForm!: FormGroup;
  closefile: any;
  actionscolumnDefs: any;
  actionsrowData: any[] = [];
  Modules: any[] = [];
  ChartOptions: any;
  Chart2Options: any;
  Chart3Options: any;
  loadingOverlayComponent: any;
  gridOptions: any = {
    frameworkComponents: {
      customLoadingOverlay: CustomLoadingOverlay,
      primeCellEditor: PrimeCellEditorComponent,
    },
  };
  gridApi: any;
  totalActions: any;
  completedActions: any;
  pendingActions: any[] = [];
  UserDDL: any;
  Departments: any[] = [];
  newModules: any[] = [];
  totalActionsCount: any;
  completedActionsCount: any;
  pendingActionsCount: any;
  totalActionObservations: any[] = [];
  totalMonthresult: any[];
  completedActionObservations: any;
  completedMonthresult: any[];
  pendingActionObservations: any;
  pendingMonthresult: any[];
  gridColumnApi: any;
  defaultColDef: any;
  targetDate: any;
  data: any;
  disableVerification = false;
  disableNewAssigne = true;
  Status: any;
  filteredstatus: any;
  RevisedDate: Date;
  ModuleName: any;
  currentAssigneeEmail: string = null;
  currentResponsibleEmail: any = null;
  currentNodeDate: any = null;
  UniqueCode: any;
  onlyWhenGrouping: any = 'onlyWhenGrouping';

  public sideBar: SideBarDef | string | string[] | boolean | null = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: false,
          suppressPivotMode: true,
          suppressColumnFilter: true,
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: true,
        },
      },
    ],
    defaultToolPanel: 'columns',
  };
  HeaderId: any;
  doc: string;
  images: any[];
  fileType: string;
  fileDesc: string;
  displayMaximizable: boolean;
  imageIndexOne = 0;
  lang: any;
  langObj: any;
  languageDir = 'ltr';
  pageId: any;
  moduleId: any;
  fileUrl: string | ArrayBuffer;
  addFile = null;
  addImage = null;
  addStatus = 'Open';
  action = '';
  addDisableVerification = false;
  addDisableNewAssigne = true;
  addActionCloseFile: any;
  deparmentList: any[] = [];
  user: any;
  employees: Employee[] = [];
  employeesTemp: any;
  imageUrl: string | ArrayBuffer;
  isAccess = ApplicationPermission.OverAll_Action_Plan_ACCESS;
  isWrite = ApplicationPermission.OverAll_Action_Plan_CREATE;
  isUpdate = ApplicationPermission.OverAll_Action_Plan_UPDATE;
  isDelete = ApplicationPermission.OverAll_Action_Plan_DELETE;
  mClassificationTypes: any[] = [];

  constructor(
    private toaster: ToastrService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private dtservice: DtServiceService,
    private actionplanService: OverallActionPlanService,
    private spinner: NgxSpinnerService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private datepickerService: DatepickerService,
    private baseApi: BaseApi,
    private employeeService: EmployeeService,
    private permissionService: PermissionService,
    private userConfigService: UserConfigurationsService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.selectedStatus = [
      { statusId: 1, name: 'Open' },
      { statusId: 3, name: 'InProgress' },
    ];
    this.status = [
      { statusId: 1, name: 'Open' },
      { statusId: 3, name: 'InProgress' },
      { statusId: 4, name: 'Closed' },
      { statusId: 5, name: 'Rejected' },
      { statusId: 6, name: 'Complete' },
      { statusId: 7, name: 'Delayed' },
      { statusId: 8, name: 'ReOpened' },
    ];

    this.defaultColDef = {
      editable: true,
      enableRowGroup: true,
      enableValue: true,
    };
    this.actionscolumnDefs = [
      {
        field: 'Actions',
        headerName: 'Actions',
        resizable: true,
        editable: false,
        cellRenderer: (params: any): any => {
          if (params?.data.Status !== 'Closed') {
            return `
          <button mat-mini-fab="" matTooltip="Edit Physical Test" tooltipPosition="top" color="primary" class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">edit</mat-icon></span><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
          `;
          }
        },
        width: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Module',
        headerName: 'Module',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        width: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'HeaderId',
        hide: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'UniqueCode',
        headerName: 'Unique Code',
        sortable: true,
        resizable: true,
        filter: true,
        wrapText: true,
        editable: false,
        width: 130,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Action',
        headerName: 'Actions (RCA & others)',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'PriorityLevelText',
        headerName: 'Priority Level',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this),
      },
      {
        field: 'Responsible',
        headerName: 'AssignTo / Responsible',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Status',
        headerName: 'Status',
        sortable: true,
        width: 100,
        resizable: true,
        filter: true,
        editable: false,
        cellStyle: function (params: any): any {
          if (params.value == 'Open')
            return { color: 'white', backgroundColor: 'gray' };
          else if (params.value == 'InProgress')
            return { color: 'white', backgroundColor: 'orange' };
          else if (params.value == 'Complete')
            return { color: 'white', backgroundColor: '#1cd51c' };
          else if (params.value == 'Closed')
            return { color: 'white', backgroundColor: 'green' };
          else if (params.value == 'Delayed')
            return { color: 'white', backgroundColor: 'brown' };
          else if (params.value == 'Rejected')
            return { color: 'white', backgroundColor: 'red' };
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ObservedDate',
        headerName: 'Observed Date',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Department',
        headerName: 'Department',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        width: 120,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Observation',
        headerName: 'Initial Problem /Observation / Root Cause Problem',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      // {
      //   field: 'PictureBefore',
      //   headerName: 'Picture Before',
      //   sortable: true,
      //   resizable: true,
      //   filter: false,
      //   hide: true,
      //   cellRenderer: function (params: any) {
      //     let html = `<img style="width: 50px; height: 40px;" src="assets/images/no-image.png"/>`;
      //     if (params && params.value) {
      //       html = `<img style="width: 50px; height: 40px;" src="${params.value}"/>`;
      //     }
      //     return html;
      //   },
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      {
        field: 'RootCause',
        headerName: 'Root Cause Problem',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },

      {
        field: 'ActionType',
        headerName: 'Action Type (Corrective/Preventive/Other)',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'PictureBefore',
        headerName: 'PictureBefore',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params?.data?.picturebefore && params?.data?.picturebefore?.slice(-9) !== '/filename') {
            html = `<button mat-mini-fab="" matTooltip="View document" tooltipPosition="top" color="primary" class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
            `;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'UploadDoc',
        headerName: 'Attachment',
        editable: false,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params?.data?.UploadDoc && params?.data?.UploadDoc.slice(-9) !== '/filename') {
            html = `<button mat-mini-fab="" matTooltip="View document" tooltipPosition="top" color="primary" class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
                  `;
          }
          return html;
        },

        // cellRenderer: function (params: any) {
        //   let html = '';
        //   if (params && params?.value?.split("/").at(-1) !== 'filename') {
        //     html = `<a download href = "${params.value}" ><i class="fa fa-download"></i></a>`;
        //   }
        //   return html;
        // },
        // cellStyle: (params: any) => {
        //   return {
        //     color: 'blue',
        //     'text-decoration': 'underline',
        //     cursor: 'pointer',
        //   };
        // },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ClosedFile',
        headerName: 'Closed File',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params?.data?.closedFile && params?.data?.closedFile?.slice(-9) !== '/filename') {
            html = `<button mat-mini-fab="" matTooltip="View document" tooltipPosition="top" color="primary" class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
                  `;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'CompletedFile',
        headerName: 'Completed File',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        cellRenderer: function (params: any) {
          let html = '';
          if (params && params?.data?.CompletedFile && params?.data?.CompletedFile?.slice(-9) !== '/filename') {
            html = `<button mat-mini-fab="" matTooltip="View document" tooltipPosition="top" color="primary" class="viewDocument mat-focus-indicator mat-mini-fab mat-button-base mat-primary" ng-reflect-color="primary"><span class="mat-button-wrapper"><mat-icon role="img" class="viewDocument mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">visibility</mat-icon></span><span matripple="" class="viewDocument mat-ripple mat-button-ripple mat-button-ripple-round" ng-reflect-disabled="false" ng-reflect-centered="false" ng-reflect-trigger="[object HTMLButtonElement]"></span><span class="mat-button-focus-overlay"></span></button>
            `;
          }
          return html;
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'AssignedDate',
        headerName: 'Assigned Date',
        sortable: true,
        resizable: true,
        filter: true,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'TargetDate',
        headerName: 'Target Date',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'RevisedDate',
        headerName: 'New/Revised Target Date',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'NoOfMisses',
        headerName: 'No of Misses',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ActionCompleted',
        headerName: 'Action Completed',
        sortable: true,
        resizable: true,
        filter: true,
        wrapText: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: ['Yes', 'No'],
        },
        editable: (params: any) => params.value === 'No',
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ActionCompletedByName',
        headerName: 'Action Completed By',
        sortable: true,
        resizable: true,
        filter: true,
        wrapText: true,
        editable: (params: any) => params.data.ActionCompleted === 'No',
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ActionCompletedOn',
        headerName: 'Action Completed On',
        sortable: true,
        resizable: true,
        filter: true,
        hide: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'Verification',
        headerName: 'Verification',
        sortable: true,
        resizable: true,
        filter: true,
        editable: (params: any) =>
          params.value === 'Disapproved' || params.value === '',
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
          values: ['Approved', 'Disapproved'],
        },
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'VerificationByName',
        headerName: 'Verified By',
        sortable: true,
        resizable: true,
        filter: true,
        wrapText: true,
        editable: false,
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'VerificationOn',
        headerName: 'Verified On',
        sortable: true,
        resizable: true,
        filter: true,
        hide: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'NewAssignee',
        headerName: 'New Assignee',
        sortable: true,
        resizable: true,
        filter: true,
        editable: false,
        hide: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'ClosedDate',
        headerName: 'Closed Date',
        sortable: true,
        resizable: true,
        filter: true,
        hide: true,
        editable: false,
        valueFormatter: (params: any) => this.formatCellData(params.value, 'dateTime'),
        headerValueGetter: this.localizeHeader.bind(this)
      },
      // {
      //   field: 'closedFile',
      //   headerName: 'Closed File',
      //   sortable: true,
      //   resizable: true,
      //   filter: true,
      //   cellRenderer: function (params: any) {
      //     let html = '';
      //     if (params && params.value) {
      //       html = `<a href = "${params.value}" ><i class="fa fa-download"></i></a>`;
      //     }
      //     return html;
      //   },
      //   hide: true,
      //   headerValueGetter: this.localizeHeader.bind(this)
      // },
      {
        field: 'Remarks',
        headerName: 'Remarks',
        sortable: true,
        resizable: true,
        filter: true,
        hide: true,
        editable: false,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        field: 'M_Classification',
        headerName: 'M Classification',
        sortable: true,
        resizable: true,
        filter: true,
        hide: true,
        editable: false,
        valueGetter: (params) => {
          const id = params.data.M_Classification;
          if (id === null) {
            return '';
          }
          const classification = this.mClassificationTypes.find(type => type.Id === id);
          return classification ? classification.Name : '';
        }
      }

    ];
    this.loadingOverlayComponent = 'customLoadingOverlay';
  }

  ngOnInit() {
    this.user = this.baseApi.getUserSession();
    this.setWeekValue(0);
    this.getNewModule();
    this.getLangWords();
    this.filterForm = this.fb.group({
      module: [''],
      department: [''],
      employee: [''],
      status: [''],
      datePicker: [''],
      startDate: [''],
      endDate: [''],
    });
    this.filterForm.get('status').setValue(this.selectedStatus);
    const date = new Date();
    const y = date.getFullYear();
    const m = date.getMonth();
    const d = date.getDate();
    const firstDay = new Date(y, m - 1, d);
    const lastDay = new Date(y, m, d);
    const selected = {
      startDate: firstDay,
      endDate: lastDay,
    };
    this.filterForm.get('startDate').setValue(firstDay);
    this.filterForm.get('endDate').setValue(lastDay);
    this.filteredstatus = this.status.slice();
    this.getMClassificationList();
  }

  formatCellData(value: any, formatType: string): string {
    return this.userConfigService.formatField(value, formatType);
  }

  getMClassificationList() {
    this.actionplanService.getMClassification().subscribe(
      (response) => {
        this.mClassificationTypes = response;
      },
      (error) => {
        this.toaster.error('Error', 'Something Went Wrong');
      }
    );
  }

  saveState() {
    var ColumnState = JSON.stringify(this.gridColumnApi.getColumnState());

    localStorage.setItem('userActions-OverAllActionsColumnState', ColumnState);
  }

  getchart1(data: any): void {
    let monthsArr: any[] = [];
    let countArr: any[] = [];
    monthsArr = data.map((item) => item.monthName);
    countArr = data.map((item) => item.count);
    this.ChartOptions = {
      chart: {
        type: 'column',
        height: 180,
        width: 300,
        spacingRight: 50,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: monthsArr,
        crosshair: true,
      },
      exporting: {
        enabled: false,
      },
      yAxis: {
        visible: false,
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: false,
          },
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [{ name: 'Months', data: countArr, color: '#62c7c7' }],
    };
    Highcharts.chart('Chart1', this.ChartOptions);
  }
  getchart2(data: any): void {
    let monthsArr: any[] = [];
    let countArr: any[] = [];
    let monthToNum = (month) => {
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return months.indexOf(month);
    };

    data.sort((a, b) => {
      return monthToNum(a.monthName) - monthToNum(b.monthName);
    });
    monthsArr = data.map((item) => item.monthName);
    countArr = data.map((item) => item.count);
    this.Chart2Options = {
      chart: {
        type: 'column',
        height: 180,
        width: 300,
        spacingRight: 50,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: monthsArr,
        crosshair: true,
      },
      exporting: {
        enabled: false,
      },
      yAxis: {
        visible: false,
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: false,
          },
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [{ name: 'Months', data: countArr, color: '#e62e8a' }],
    };
    Highcharts.chart('Chart2', this.Chart2Options);
  }
  getchart3(data: any): void {
    let monthsArr: any[] = [];
    let countArr: any[] = [];
    monthsArr = data.map((item) => item.monthName);
    countArr = data.map((item) => item.count);
    this.Chart3Options = {
      chart: {
        type: 'column',
        height: 180,
        width: 300,
        spacingRight: 50,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: monthsArr,
        crosshair: true,
      },
      exporting: {
        enabled: false,
      },
      yAxis: {
        visible: false,
        min: 0,
        title: {
          text: '',
        },
      },
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat:
          '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
        footerFormat: '</table>',
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: false,
          },
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [{ name: 'Months', data: countArr, color: '#091182' }],
    };
    Highcharts.chart('Chart3', this.Chart3Options);
  }

  getNewModule() {
    this.spinner.show();
    this.actionplanService.getNewModule().pipe(finalize(() => this.spinner.hide())).subscribe((res: any) => {
      const a = { ID: 0, Name: 'RCA' };
      res.unshift(a);
      this.newModules = res;
      this.filterForm.get('module').setValue(this.newModules);
      this.getDepartments();
    });
  }

  getEmployees() {
    this.spinner.show()
    this.employeeService.getAllEmployees().pipe(finalize(() => this.spinner.hide())).subscribe(
      (res: any) => {
        this.employees = res;
        this.employeesTemp = this.employees;
        this.filterForm.get('employee').setValue(this.employees);
        this.GetActionPlan();
      },
      (err: any) => { }
    )
  }

  GetActionPlan(): void {
    const module = this.filterForm.value.module?.map((x: any) => x.ID).toString();
    const department = this.filterForm.value.department?.map(x => x.TypeId).toString();
    const employee = this.filterForm.value.employee?.map(x => x.employeeCode).toString();
    const status = this.filterForm.value.status?.map(x => x.name).toString();
    const startDate = moment(this.filterForm.value.startDate).utc();
    const endDate = new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 59));

    const key = {
      fromDate: startDate,
      toDate: endDate,
      module,
      department,
      employee,
      status,
    };
    this.actionsrowData = [];
    this.totalActions = [];
    this.spinner.show();
    this.actionplanService.GetActionPlan(key).pipe(finalize(() => this.spinner.hide())).subscribe((res: any) => {
      this.actionsrowData = res?.data;
      this.autoSizeAllColumns();
      this.totalActions = res?.chartData;
      this.totalActionObservations = this.totalActions?.map(
        (item) => item.ObservedDate
      );
      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',];
      var group = this.totalActionObservations?.reduce(function (r, o) {
        var date = new Date(o);
        var month = date.getMonth();
        var monthName = monthNames[month];
        r[monthName] ? r[monthName].count++ : (r[monthName] = { monthName: monthName, count: 1 });
        return r;
      }, {});
      this.totalMonthresult = Object.keys(group)?.map((key) => group[key]).reverse();
      this.getchart1(this.totalMonthresult);
      this.totalActionsCount = res?.chartData.length;
      this.completedActions = res.chartData?.filter((obj) => obj.Status === 'Closed');
      this.completedActionsCount = this.completedActions.length;
      this.completedActionObservations = this.completedActions?.map((item) => item.ObservedDate);
      var compgroup = this.completedActionObservations?.reduce(function (r, o) {
        var date = new Date(o);
        var month = date.getMonth();
        var monthName = monthNames[month];
        r[monthName] ? r[monthName].count++ : (r[monthName] = { monthName: monthName, count: 1 });
        return r;
      }, {});
      this.completedMonthresult = Object?.keys(compgroup)?.map((key) => compgroup[key]);
      this.getchart2(this.completedMonthresult);
      this.pendingActions = [];
      this.totalActions?.forEach((element) => {
        if (element.Status === 'InProgress' || element.Status === 'Open' || element.Status === 'Delayed') {
          this.pendingActions?.push(element);
        }
      });
      this.pendingActionsCount = this.pendingActions.length;
      this.pendingActionObservations = this.pendingActions?.map(
        (item) => item.ObservedDate
      );
      var pendinggroup = this.pendingActionObservations?.reduce(function (r, o) {
        var date = new Date(o);
        var month = date.getMonth();
        var monthName = monthNames[month];
        r[monthName] ? r[monthName].count++ : (r[monthName] = { monthName: monthName, count: 1 });
        return r;
      }, {});
      this.pendingMonthresult = Object?.keys(pendinggroup)?.map((key) => pendinggroup[key])?.reverse();
      this.getchart3(this.pendingMonthresult);
    });
  }

  onColumnPivotChanged(e: any) {
    var ColumnState = JSON.stringify(this.gridColumnApi.getColumnState());
    localStorage.setItem('userActions-OverAllActionsColumnState', ColumnState);
  }

  onInputChange(event: any): void {
    this.GetActionPlan();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setDomLayout('autoHeight');
    const element: HTMLElement = document.querySelector(
      '#mainGrid'
    ) as HTMLElement;
    if (element !== null) {
      element.style.height = '';
    }
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
    var columnState = JSON.parse(
      localStorage.getItem('userActions-OverAllActionsColumnState')
    );
    if (columnState) {
      params.columnApi.setColumnState(columnState);
    }
    this.autoSizeAllColumns();
  }
  autoSizeAllColumns() {
    this.gridApi.setRowData(this.actionsrowData);
    this.gridColumnApi.autoSizeAllColumns();
  }
  onFilterChanged(params): any {
    localStorage.setItem(
      'ag-grid-persistane-filtering',
      JSON.stringify(params.api.getFilterModel())
    );
  }
  onFirstDataRendered(params): void {
    const filterModel = localStorage.getItem('ag-grid-persistane-filtering');
    params.api.setFilterModel(JSON.parse(filterModel));
  }

  getDepartments() {
    const key = {};
    this.spinner.show();
    this.actionplanService.getDeptData(key).pipe(finalize(() => { this.spinner.hide() })).subscribe(
      (res: any) => {
        const a = { TypeId: 0, TypeName: 'NA' };
        res.unshift(a);
        this.Departments = res;
        this.filterForm.get('department').setValue(this.Departments);
        this.getEmployees();
      },
      (error) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  openAddActionModal(editMode: boolean = false, params: any = null): void {
    if (this.permissionService.isUserHasPermission(this.isWrite)) {
      const dialogRef = this.dialog.open(AddActionModalComponent, {
        width: '80%',
        height: 'auto',
        data: {
          message: 'This is a common message.',
          userList: this.employees,
          ID: 2,
          Plant: this.baseApi.getPlantCodeFromStorage(),
          ModuleId: params?.data?.ModuleId ?? 4,
          params: params?.node?.data ?? null,
          editMode: editMode,
          TableId: params?.data?.TableId ?? 0
        },
      });
      dialogRef.afterClosed().subscribe((dataSaved: boolean) => {
        dataSaved && this.GetActionPlan();
      });
    }
    else { this.toaster.warning('warn', 'User Dont have permitions') }
  }

  onTDateChange(): void {
    if (this.filterForm.value.endDate == null || this.filterForm.value.startDate == null) return;
    this.GetActionPlan();
  }

  setWeekValue(weekDay: number): void {
    if (weekDay == undefined || weekDay == null || Number.isNaN(weekDay))
      weekDay = 0
    sessionStorage.removeItem('weekDay');
    sessionStorage.setItem('weekDay', weekDay.toString());
    this.datepickerService.getFirstDayOfWeek()
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    this.pageId = this.baseApi.getCurrentMenuID();
    const userMenus = this.baseApi.getUserPermissionsSession();
    this.moduleId = userMenus.find(x => x.menuId === this.pageId)?.parentId;
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi.refreshHeader();
      }
    });
  }

  uponHide() {
    this.displayMaximizable = false;
  }

  previewImageModal(params: any): void {
    this.dialog.open(ImageDialogComponent, {
      height: '90%',
      width: '90%',
      data: params.value ?? 'assets/images/no-image.png',
    });
  }

  setPopupbtns(): void {
    var pHeader = document.getElementsByClassName('p-dialog-header')[0] as HTMLElement;
    if (pHeader) {
      pHeader.style.display = 'flex';
      pHeader.style.justifyContent = 'flex-end';
      var pHeaderIcons = document.getElementsByClassName("p-dialog-header-icons")[0] as HTMLElement;
      pHeaderIcons.style.marginRight = '40px';
    }
  }


  cellClicked(params: any): void {
    const ButtonType = params.event.target.textContent;
    const col = params.colDef.field;
    let classList = params.event.target.classList;
    this.doc = '';
    this.fileType = '';
    if (ButtonType === 'edit') this.openAddActionModal(true, params);

    // if (col === 'picturebefore') this.previewImageModal(params.value);

    if (col === 'ClosedFile' && classList.contains('viewDocument')) {
      this.doc = params.data.closedFile;
      const fileType: any = this.doc.split('.').pop().toLowerCase();
      if (['jpeg', 'jpg', 'png', 'gif'].includes(fileType)) {
        this.images = [this.doc];
        this.fileType = 'img';
      } else if (fileType.split("/").at(-1) === 'filename') {
        this.images = ["assets/images/no-image.png"];
        this.fileType = 'img';
      } else this.fileType = 'doc';

      this.fileDesc = (params.data?.closedFile?.split("uploads/")[1]?.split("_(20")[0] || 'No Image Available') +
        (fileType ? '.' + fileType : '');
      this.displayMaximizable = true;
      setTimeout(() => {
        this.setPopupbtns();
      }, 500);
    }

    if (col === 'CompletedFile' && classList.contains('viewDocument')) {
      this.doc = params.data.CompletedFile;
      const fileType: any = this.doc.split('.').pop().toLowerCase();
      if (['jpeg', 'jpg', 'png', 'gif'].includes(fileType)) {
        this.images = [this.doc];
        this.fileType = 'img';
      } else if (fileType.split("/").at(-1) === 'filename') {
        this.images = ["assets/images/no-image.png"];
        this.fileType = 'img';
      } else this.fileType = 'doc';

      this.fileDesc = params.data?.CompletedFile.split("uploads/")[1]?.split("_(20")[0] ?? 'No Image Available';
      this.displayMaximizable = true;
      setTimeout(() => {
        this.setPopupbtns();
      }, 500);
    }

    if (col === 'UploadDoc' && classList.contains('viewDocument')) {
      this.doc = params.data.UploadDoc;
      const fileType: any = this.doc.split('.').pop().toLowerCase();
      if (['jpeg', 'jpg', 'png', 'gif'].includes(fileType)) {
        this.images = [this.doc];
        this.fileType = 'img';
      } else if (fileType.split("/").at(-1) === 'filename') {
        this.images = ["assets/images/no-image.png"];
        this.fileType = 'img';
      } else this.fileType = 'doc';

      this.fileDesc = params.data?.UploadDoc.split("uploads/")[1]?.split("_(20")[0] ?? 'No Image Available';
      this.displayMaximizable = true;
      setTimeout(() => {
        this.setPopupbtns();
      }, 500);
    }

    if (col === 'PictureBefore' && classList.contains('viewDocument')) {
      this.doc = params.data.picturebefore;
      const fileType: any = this.doc.split('.').pop().toLowerCase();
      if (['jpeg', 'jpg', 'png', 'gif'].includes(fileType)) {
        this.images = [this.doc];
        this.fileType = 'img';
      } else if (fileType.split("/").at(-1) === 'filename') {
        this.images = ["assets/images/no-image.png"];
        this.fileType = 'img';
      } else this.fileType = 'doc';

      this.fileDesc = params.data?.picturebefore.split("uploads/")[1]?.split("_(20")[0] ?? 'No Image Available';
      this.displayMaximizable = true;
      setTimeout(() => {
        this.setPopupbtns();
      }, 500);
    }
  }
}


function myDateComparator(filterLocalDateAtMidnight: any, cellValue: any): any {
  const dateAsString = cellValue;
  if (dateAsString == null) return 0;
  const dateParts = dateAsString.split('/');
  const year = Number(dateParts[2]);
  const month = Number(dateParts[1]) - 1;
  const day = Number(dateParts[0]);
  const cellDate = new Date(year, month, day);

  if (cellDate < filterLocalDateAtMidnight) return -1;
  else if (cellDate > filterLocalDateAtMidnight) return 1;
  else return 0;
}
